import {
  buildDateRangeFilters,
  buildInFilter,
  mergeFilters,
} from '@/ui/composites/grid/gridFilters';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { SuiteRunStatus } from '@flowqa/shared';

type GridFilters = GridQueryInput['filters'];

type BuildSelectedDayFiltersInput = {
  field: 'createdAt' | 'startedAt';
  selectedEndDay: string | null;
  selectedStartDay: string | null;
};

type BuildExecutionRunSharedFiltersInput = {
  executionRunDateRangeFilters: GridFilters;
  executionRunSearchFilters: GridFilters;
  projectFilters: GridFilters;
  selectedExecutionRunDayFilters: GridFilters;
  selectedStatuses: SuiteRunStatus[];
  tagFilters: GridFilters;
};

export const buildSelectedDayFilters = ({
  field,
  selectedEndDay,
  selectedStartDay,
}: BuildSelectedDayFiltersInput): GridFilters => {
  if (!selectedStartDay && !selectedEndDay) {
    return [];
  }

  const start = selectedStartDay ? `${selectedStartDay}T00:00:00.000Z` : null;
  const end = selectedEndDay ? `${selectedEndDay}T23:59:59.999Z` : null;
  return buildDateRangeFilters(field, start, end);
};

export const buildExecutionRunSharedFilters = ({
  executionRunDateRangeFilters,
  executionRunSearchFilters,
  projectFilters,
  selectedExecutionRunDayFilters,
  selectedStatuses,
  tagFilters,
}: BuildExecutionRunSharedFiltersInput): GridFilters => {
  return mergeFilters(
    selectedExecutionRunDayFilters,
    executionRunDateRangeFilters,
    executionRunSearchFilters,
    buildInFilter('status', selectedStatuses),
    tagFilters,
    projectFilters,
  );
};
